import { render, staticRenderFns } from "./RecrutestBanner.vue?vue&type=template&id=0fafc46c&scoped=true"
import script from "./RecrutestBanner.vue?vue&type=script&lang=js"
export * from "./RecrutestBanner.vue?vue&type=script&lang=js"
import style0 from "./RecrutestBanner.vue?vue&type=style&index=0&id=0fafc46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafc46c",
  null
  
)

export default component.exports